<div class="bg">
    <app-toolbar *ngIf="toolbar"></app-toolbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>